import "date-fns";
import React, {Fragment} from "react";
import {
MuiPickersUtilsProvider,
KeyboardDatePicker,
} from "@material-ui/pickers";
import FormControl from "@material-ui/core/FormControl";
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";
import { useStyles } from "./style";
import FormHelperText from "@material-ui/core/FormHelperText";
import { IconButton, InputAdornment, Tooltip, Grid } from "@material-ui/core";
import { Block, Edit } from "@material-ui/icons";

export default function FormControlDate(props) {
	const classes = useStyles();
	const [values, setValues] = React.useState({ valor: '', active: props.disabled,});

	const handleClickShowPassword = () => {
		setValues({ ...values, active: !values.active });
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};	      
	return (
		<div >
			<Grid container >
				{
					props.modified ? 
						<>
							<Grid item xs={10}>          
								<FormControl>
									<MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
										<KeyboardDatePicker
											maxDateMessage="La fecha no debe ser posterior a la fecha máxima"
											minDateMessage="La fecha no debe ser anterior a la fecha mínima"											
											maxDate={new Date()}
											className={classes.KeyboardDatePicker}
											variant="inline"
											format="dd/MM/yyyy"
											margin="normal"
											id={props.name}
											name={props.name}
											key={props.name}
											error={props.isError}
											// label={props.label}
											placeholder={props.label}
											helperText={props.label}
											value={props.value}
											disabled={values.active}
											onChange={(date) => {
											props.handleChange({ target: { name: props.name, value: date } });
											}}
											KeyboardButtonProps={{
											"aria-label": "change date",
											}}
											invalidDateMessage={props.isError ? null:"Ingrese un formato válido"}
										/>
									</MuiPickersUtilsProvider>
								</FormControl>        
							</Grid>    
							<Grid item xs={2} className={classes.icon}>              
								<InputAdornment position="start" >
									<Tooltip title={values.active ? "editar Fecha" : 'Bloquear Fecha'}>
										<IconButton
											aria-label="toggle password visibility"
											onClick={handleClickShowPassword}
											onMouseDown={handleMouseDownPassword}
										>
											{values.active ? <Edit /> : <Block />}
										</IconButton>
									</Tooltip>
								</InputAdornment>
							</Grid>  
						</>
					:
						<Grid item xs={12}>          
							<FormControl className={classes.formControl}>
								<MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
									<KeyboardDatePicker
										maxDateMessage="La fecha no debe ser posterior a la fecha máxima"
										minDateMessage="La fecha no debe ser anterior a la fecha mínima"
										maxDate={new Date()}									
										className={classes.KeyboardDatePicker}
										variant="inline"
										format="dd/MM/yyyy"
										margin="normal"
										id={props.name}
										name={props.name}
										key={props.name}
										error={props.isError}
										// label={props.label}
										placeholder={props.label}
										helperText={props.label}
										value={props.value}
										disabled={values.active}
										onChange={(date) => {
										props.handleChange({ target: { name: props.name, value: date } });
										}}
										KeyboardButtonProps={{
										"aria-label": "change date",
										}}
										invalidDateMessage={props.isError ? null:"Ingrese un formato válido"}
									/>
								</MuiPickersUtilsProvider>
								{
									props.isError ? ( <FormHelperText className={classes.textError} id="component-error-text">{props.errorMessages}</FormHelperText>) 
									: <FormHelperText className={classes.textSuccess} id="component-success-text">{props.errorMessages}</FormHelperText>
								}								
							</FormControl>        
						</Grid>                  
				}              
			</Grid>
		</div>
	);
}